const sign = require('jwt-encode')

const clientSettings = {
  appName: 'P3SMPT',
  os: 'web',
  ostype: 'desktop',
  appId: '1',
  appKey: 'm3nUJu13inT4N69Em1l4nGc4hayA'
}

const createNewHeaders = (token) => {
  // const data = {
  //   app_id: clientSettings.appId
  //   // iat: date.getTime()
  // }

  const uuid = localStorage.getItem('uuid')
  localStorage.setItem('apptoken', token)
  window.customHeaders = {
    UUID: uuid,
    APPTOKEN: token
  }
  // console.log('customHeaders = ' + window.customHeaders)
  // const localHeaders = {
  //   UUID: uuid,
  //   APPTOKEN: token
  // }
  // localStorage.setItem('headers' + localHeaders)
}

const updateHeaders = () => {
  const uuid = localStorage.getItem('UUID')
  const uid = localStorage.getItem('UID')
  const token = localStorage.getItem('apptoken')
  const token2 = localStorage.getItem('token')

  window.customHeaders = {
    UUID: uuid,
    UID: uid,
    APPTOKEN: token,
    TOKEN: token2
  }

}


const executePost = async (url, formData) => {

  updateHeaders()
  if (window.customHeaders === undefined) {
    console.log('header undefined')
  }

  try {
    const postData = {
      method: 'post',
      headers: window.customHeaders,
      body: formData
    }
    const response = await fetch(url, postData)
    const json = await response.text();
    return JSON.parse(json)
  } catch (error) {
    const errorObj = {
      code: 500,
      msg: 'Network Error'
    }
    return errorObj
  }
}


const signout = () => {
  try {
    localStorage.removeItem("token");
    alert("You have been signed out successfully."); // Menampilkan pesan sukses
  } catch (error) {
    console.error("Error occurred while signing out:", error);
  }
};

const executeDelete = async (url, key) => {
  if (window.customHeaders === undefined) {
    const uuid = localStorage.getItem('uuid')
    const token = localStorage.getItem('token')
    const uid = localStorage.getItem('UID')

    window.customHeaders = {
      UUID: uuid,
      UID: uid,
      OS: clientSettings.os,
      Authorization: token
    }
  }
  try {
    const postData = {
      method: 'post',
      headers: window.customHeaders
    }
    const response = await fetch(`${url}/${key}`, postData)
    const json = await response.text()
    //console.log(json);
    return JSON.parse(json)
  } catch (error) {
    const errorObj = {
      code: 500,
      msg: 'Network Error'
    }
    //console.log(error);
    return errorObj
  }
}

const executeRefreshToken = async (url, dataForm) => {
  updateHeaders()
  try {
    const formData = new FormData()
    formData.append('token', localStorage.getItem('primaryKey'))
    formData.append('token2', localStorage.getItem('secondKey'))

    const postData = {
      method: 'post',
      headers: window.customHeaders,
      body: formData
    }

    const response = await fetch('REFRESH_TOKEN', postData)
    const json = await response.text()
    console.log('JSON refersh = ' + json)

    const jsonParse = JSON.parse(json)
    console.log(jsonParse.code)
    if (jsonParse.code == 200) {
      localStorage.setItem('token', `${'Bearer '}${jsonParse.token}`)
      localStorage.setItem('primaryKey', jsonParse.token)
      localStorage.setItem('secondKey', jsonParse.token2)

      executePost(url, dataForm)
    } else {
    }
    // return JSON.parse(json)
  } catch (error) {
    const errorObj = {
      code: 500,
      msg: 'Network Error'
    }
    //console.log(error);
    return errorObj
  }
}

const executeGet = async (url, id = null) => {

  if (id != null) {
    url = `${url}/${id}`
  }
  updateHeaders()
  if (window.customHeaders === undefined) {
    const uuid = localStorage.getItem('uuid')
    const token = localStorage.getItem('token')
    const uid = localStorage.getItem('UID')

    window.customHeaders = {
      UUID: uuid,
      UID: uid,
      OS: clientSettings.os,
      Authorization: token
    }
  }

  try {
    const postData = {
      method: 'get',
      headers: window.customHeaders
    }
    const response = await fetch(url, postData)
    const json = await response.json()
    return json
  } catch (error) {
    //console.log(error);
    console.log('error respone = ' + error)
    const errorObj = {
      code: 500,
      msg: 'Network Error'
    }
    return errorObj
  }
}

export { clientSettings, createNewHeaders, executeGet, executePost, executeDelete, updateHeaders, signout }
